import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['row', 'template', 'email'];

  connect() {
    // Safari can ignore the server-rendered value of `multiple` email inputs;
    // reassigning forces the prefilled vendor address to render.
    this.emailTargets.forEach((input) => {
      input.value = input.value;
    });
  }

  add(event) {
    event.preventDefault();
    const row = this.templateTarget.content.firstElementChild.cloneNode(true);
    event.currentTarget.insertAdjacentElement('beforebegin', row);
    this.#toggleDeleteIcons();
    row.querySelector('input').focus();
  }

  remove(event) {
    event.currentTarget.closest('.send-billable-form__recipient-email-container').remove();
    this.#toggleDeleteIcons();
  }

  #toggleDeleteIcons() {
    const display = this.rowTargets.length === 1 ? 'none' : 'inline-block';
    this.rowTargets.forEach((row) => {
      row.querySelector('.delete-billable-recipient-email-field').style.display = display;
    });
  }
}
